import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { globalThis } from "./server-safe-globals.js";
import { MediaUIEvents, MediaUIAttributes } from "../constants.js";

var splitTextTracksStr = function splitTextTracksStr() {
  var textTracksStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return textTracksStr.split(/\s+/);
};

var parseTextTrackStr = function parseTextTrackStr() {
  var textTrackStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _textTrackStr$split = textTrackStr.split(":"),
      _textTrackStr$split2 = _slicedToArray(_textTrackStr$split, 3),
      kind = _textTrackStr$split2[0],
      language = _textTrackStr$split2[1],
      encodedLabel = _textTrackStr$split2[2];

  var label = encodedLabel ? decodeURIComponent(encodedLabel) : void 0;
  kind = kind === "cc" ? "captions" : "subtitles";
  return {
    kind: kind,
    language: language,
    label: label
  };
};

var parseTextTracksStr = function parseTextTracksStr() {
  var textTracksStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var textTrackLikeObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return splitTextTracksStr(textTracksStr).map(function (textTrackStr) {
    var textTrackObj = parseTextTrackStr(textTrackStr);
    return _objectSpread(_objectSpread({}, textTrackLikeObj), textTrackObj);
  });
};

var parseTracks = function parseTracks(trackOrTracks) {
  if (Array.isArray(trackOrTracks)) {
    return trackOrTracks.map(function (trackObjOrStr) {
      if (typeof trackObjOrStr === "string") {
        return parseTextTrackStr(trackObjOrStr);
      }

      return trackObjOrStr;
    });
  }

  if (typeof trackOrTracks === "string") {
    return parseTextTracksStr(trackOrTracks);
  }

  return [trackOrTracks];
};

var formatTextTrackObj = function formatTextTrackObj() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    kind: "subtitles"
  },
      kind = _ref.kind,
      label = _ref.label,
      language = _ref.language;

  if (!label) return language;
  return "".concat(kind === "captions" ? "cc" : "sb", ":").concat(language, ":").concat(encodeURIComponent(label));
};

var stringifyTextTrackList = function stringifyTextTrackList() {
  var textTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.prototype.map.call(textTracks, formatTextTrackObj).join(" ");
};

var isMatchingPropOf = function isMatchingPropOf(key, value) {
  return function (obj) {
    return obj[key] === value;
  };
};

var textTrackObjAsPred = function textTrackObjAsPred(filterObj) {
  var preds = Object.entries(filterObj).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return isMatchingPropOf(key, value);
  });
  return function (textTrack) {
    return preds.every(function (pred) {
      return pred(textTrack);
    });
  };
};

var updateTracksModeTo = function updateTracksModeTo(mode) {
  var tracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var tracksToUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var preds = parseTracks(tracksToUpdate).map(textTrackObjAsPred);

  var isTrackToUpdate = function isTrackToUpdate(textTrack) {
    return preds.some(function (pred) {
      return pred(textTrack);
    });
  };

  Array.from(tracks).filter(isTrackToUpdate).forEach(function (textTrack) {
    textTrack.mode = mode;
  });
};

var getTextTracksList = function getTextTracksList(media) {
  var filterPredOrObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  if (!(media == null ? void 0 : media.textTracks)) return [];
  var filterPred = typeof filterPredOrObj === "function" ? filterPredOrObj : textTrackObjAsPred(filterPredOrObj);
  return Array.from(media.textTracks).filter(filterPred);
};

var areSubsOn = function areSubsOn(el) {
  var showingSubtitles = !!el.getAttribute(MediaUIAttributes.MEDIA_SUBTITLES_SHOWING);
  return showingSubtitles;
};

var toggleSubsCaps = function toggleSubsCaps(el, force) {
  var _a, _b;

  var subsOn = areSubsOn(el);

  if (subsOn || force === false) {
    var subtitlesShowingStr = el.getAttribute(MediaUIAttributes.MEDIA_SUBTITLES_SHOWING);

    if (subtitlesShowingStr) {
      var evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_DISABLE_SUBTITLES_REQUEST, {
        composed: true,
        bubbles: true,
        detail: subtitlesShowingStr
      });
      el.dispatchEvent(evt);
    }
  } else if (!subsOn || force === true) {
    var _ref4 = (_b = splitTextTracksStr((_a = el.getAttribute(MediaUIAttributes.MEDIA_SUBTITLES_LIST)) != null ? _a : "")) != null ? _b : [],
        _ref5 = _slicedToArray(_ref4, 1),
        subTrackStr = _ref5[0];

    if (subTrackStr) {
      var _evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_SHOW_SUBTITLES_REQUEST, {
        composed: true,
        bubbles: true,
        detail: subTrackStr
      });

      el.dispatchEvent(_evt);
    }
  } else {
    console.error("Attempting to enable captions or subtitles but none are available! Please verify your media content if this is unexpected.");
  }
};

export { areSubsOn, formatTextTrackObj, getTextTracksList, isMatchingPropOf, parseTextTrackStr, parseTextTracksStr, parseTracks, splitTextTracksStr, stringifyTextTrackList, textTrackObjAsPred, toggleSubsCaps, updateTracksModeTo };